import React from 'react';
import { useNavigate } from 'react-router-dom';

// Importación de imágenes
import logoRockstar from '../assets/images/logo_rockstars.png';
import titulo from '../assets/images/del_otro_lado_del_telon.png';
import silueta1 from '../assets/images/silueta_1.png';
import silueta2 from '../assets/images/silueta_2.png';
import silueta3 from '../assets/images/silueta_3.png';
import silueta4 from '../assets/images/silueta_4.png';
import silueta5 from '../assets/images/silueta_5.png';
import silueta6 from '../assets/images/silueta_6.png';

const HeroBanner = () => {
    const navigate = useNavigate();

    const handleNavigation = () => {
        navigate('/');
    };

    return (
        <div className="hero-banner">
            {/* Título */}
            <div className="hero-title" onClick={handleNavigation} style={{ cursor: 'pointer' }}>
                <img src={titulo} alt="Del otro lado del telón" />
            </div>

            {/* Rockstar logo */}
            <div className="hero-logo" onClick={handleNavigation} style={{ cursor: 'pointer' }}>
                <img src={logoRockstar} alt="Rockstar" />
            </div>

            {/* Elementos decorativos */}
            <img className="silueta silueta-1" src={silueta1} alt="Decoración 1" />
            <img className="silueta silueta-2" src={silueta2} alt="Decoración 2" />
            <img className="silueta silueta-3" src={silueta3} alt="Decoración 3" />
            <img className="silueta silueta-4" src={silueta4} alt="Decoración 4" />
            <img className="silueta silueta-5" src={silueta5} alt="Decoración 5" />
            <img className="silueta silueta-6" src={silueta6} alt="Decoración 6" />
        </div>
    );
};

export default HeroBanner;
